entityTypes = function (admin) {
	var objEntityTypes = {};
	var newParent = null;
	var objDialog = dialog();
	var url = '/admin/';

	if (admin === undefined || admin === null) {
		url = '/admin/';
	} else if (admin) {
		url = '/admin/';
	} else if (!admin) {
		url = '/';
	}

	/**
	 * entityTypesList calls the ajax to get the latest html for displaying
	 * the list
	 */
	// objEntityTypes.entityTypesList = function(show) {
	// 	// Get the List
	// 	var params = {
	// 		display : 'ajaxList'
	// 	};

	// 	$.ajax({
	// 		url: url + 'entityType',
	// 		type: 'get',
	// 		data: params,
	// 		beforeSend: function() {
	// 			domObject.addLoadingMask('#curriculog-types-column-content');
	// 		},
	// 		success: function(data) {
	// 			$('.hierarchy-types').removeClass('active');

	// 			$('#entity-types').remove();
	// 			$(data).appendTo('#curriculog-types-column-content');

	// 			objEntityTypes.createEntityTypeSelect('entity-details-type','');
	// 			objEntityTypes.createEntityTypeSelect('entity-new-type','');

	// 			if ( show === true ) {
	// 				$('#entity-types').addClass('active');
	// 			}

	// 			domObject.removeMask('#curriculog-types-column-content');
	// 			objEntityTypes.verticalStretch();
	// 		}
	// 	});

	// };

	/**
	 * entityTypesList calls the ajax to get the latest html for displaying
	 * the list as a select drop down form element
	 */
	objEntityTypes.createEntityTypeSelect = function(selectId, currentId) {
		var select = $('#'+ selectId);
		var selectedOptionValue = select.children(':selected').val();
		select.contents().remove();

		if ($('#entity-types .curriculog-types-current-type').length < 1) {
			$('#'+selectId).append('<option value="" disabled="disabled" selected>No Entity Types</option>');
		} else {
			$('#entity-types .curriculog-types-current-type').each(function() {
				var option = $('<option></option>');
				option.val(($(this).attr('id')).replace('entity-type-',''));
				option.text($(this).children('.type-name').text());
				if (currentId === option.val()) {
					option.attr('disabled',true);
				}
				$('#'+selectId).append(option);
			});

			// Reselect the same option if it exists.
			select.children('[value="' + selectedOptionValue + '"]').prop('selected', true);
		}
	};

	objEntityTypes.createEntityTypeSelectAjax = function(selectId) {
		$.get(url + 'entityType.json', {}, function(data) {
			$('#' + selectId).contents().remove();
			if (data.hasOwnProperty('types')){
				$.each(data.types, function(index, entityType) {
					// append option with appropriate non-breaking spaces to the select box
					escapedEntityTypeName = escapeUserInput(entityType.name);
					$('#' + selectId).append($('<option></option>').val(entityType.id).html(escapedEntityTypeName));
				});
			}
		});
	};

	// objEntityTypes.refreshList = function() {
	// 	try {
	// 		var setActive = false;

	// 		if ('entity-types' === ($('div#curriculog-types-column-tooltabs li.active').attr('id')).replace('-tab','')) {
	// 			setActive = true;
	// 		}
	// 		objEntityTypes.entityTypesList(setActive);
	// 	} catch (e) {}
	// };

	/*
	 * Function newEntityType
	 * Purpose: gathers information from the form to update
	 * or create new entity type
	 */
	// objEntityTypes.newEntityType = function() {
	// 	try {
	// 		// Disable the form
	// 		$('#entity-types .type-submit').attr('disabled', 'disabled');

	// 		var id = myUniquer.create();

	// 		var postData = {
	// 			name:$('#entity-type-name').val()
	// 		};

	// 		if ( $('#entity-type-id').val().trim().length !== 0 ) {
	// 			var urlPut = '/admin/entityType:' + $('#entity-type-id').val().trim();
	// 			$.ajax({
	// 				url: urlPut,
	// 				type: 'put',
	// 				data: postData,
	// 				beforeSend: function() {
	// 					domObject.addLoadingMask('.curriculog-types-new-type');
	// 				},
	// 				success: function(){
	// 					domObject.removeMask('.curriculog-types-new-type');
	// 					objEntityTypes.refreshList();
	// 				}
	// 			});
	// 		} else {
	// 			$.ajax({
	// 				url: '/admin/entityType',
	// 				type: 'POST',
	// 				data: postData,
	// 				beforeSend: function() {
	// 					domObject.addLoadingMask('.curriculog-types-new-type');
	// 				},
	// 				success: function(){
	// 					domObject.removeMask('.curriculog-types-new-type');
	// 					objEntityTypes.refreshList();
	// 				}
	// 			});
	// 		}
	// 	} catch (err) {
	// 		return false;
	// 	}
	// };

	// objEntityTypes.editEntityType = function(typeId) {
	// 	try {
	// 		if (typeId === undefined) {
	// 			return false;
	// 		}

	// 		// Set entity name in form
	// 		$('#entity-type-name').val($('#' + typeId + ' .type-name').html().trim());

	// 		//Set entity type id
	// 		$('#entity-type-id').val(typeId.replace('entity-type-', ''));

	// 		// Change submit button to say 'Update Type'
	// 		$('#entity-types .type-submit').attr('value','Update Type').removeAttr('disabled');
	// 		$('#entity-types .type-reset').removeAttr('disabled');
	// 		$('#entity-types li.curriculog-types-new-type form h1').text('Update Entity Type');
	// 	} catch (err) {
	// 		return false;
	// 	}
	// };

	// objEntityTypes.resetEntityTypeForm = function() {
	// 	try {
	// 		//Set entity type id
	// 		$('#entity-type-id').val('');

	// 		// Change submit button to say 'Update Type'
	// 		$('#entity-types .type-submit').attr('value','Create Type');
	// 		$('#entity-types li.curriculog-types-new-type form h1').text('New Entity Type');
	// 		objEntityTypes.refreshList();
	// 	} catch(err) {
	// 		return false;
	// 	}
	// };

	// objEntityTypes.validateForm = function(typeId, which) {
	// 	if (which !== 13) {
	// 		if ($(typeId).val().trim() === '') {
	// 			$('#entity-types .type-submit').attr('disabled', 'disabled');
	// 			$('#entity-types .type-reset').attr('disabled', 'disabled');
	// 		} else {
	// 			$('#entity-types .type-submit').removeAttr('disabled');
	// 			$('#entity-types .type-reset').removeAttr('disabled');
	// 		}
	// 	}
	// };

	// objEntityTypes.deleteEntityType = function(typeId) {
	// 	try {
	// 		if (typeId === undefined || typeId === null) {
	// 			return false;
	// 		}

	// 		$('#' + typeId).addClass('curriculog-remove-warning-highlight');

	// 		var postData = {};
	// 		var currentId = typeId.replace('entity-type-', '');
	// 		var typesCount = $('#entity-types li.curriculog-types-current-type').size();
	// 		var hasChildren = ($('.' + typeId).length > 0) ? true : false;

	// 		if ( typesCount === 1 && hasChildren ) {
	// 			// Display message that they need to have more than 1 type to delete it
	// 			objEntityTypes.deleteFailed(currentId, typesCount);
	// 		} else if (hasChildren) {
	// 			// put up dialog, displaying a message to set new parent
	// 			objEntityTypes.releaseOwnership(currentId);
	// 		} else {
	// 			var dialog = objDialog.createBasicWarningDialog('remove-entity-type', function(dialog, defaults) {
	// 				// Message
	// 				$(dialog).append('You are deleting the <span class="strong">' + $('#' + typeId + ' .type-name').html() + '</span> entity type. Are you sure you want to continue?');
	// 				// Actions
	// 				defaults.buttons = {
	// 					'Delete Type': function() {
	// 						$(this).dialog('close');
	// 						$(this).remove();
	// 						var urlDelete = '/admin/entityType:' + currentId + '.json';
	// 						$.ajax({
	// 							url: urlDelete,
	// 							type: 'delete',
	// 							async: false,
	// 							data: postData,
	// 							success: function (result) {
	// 								if (+result.success === 1) {
	// 									objEntityTypes.refreshList();
	// 								} else {
	// 									objEntityTypes.deleteFailed(currentId);
	// 								}
	// 							}
	// 						});
	// 					},
	// 					Cancel: function() {
	// 						$('#' + typeId).removeClass('curriculog-remove-warning-highlight');
	// 						$(this).dialog('close');
	// 						$(this).remove();
	// 					}
	// 				};
	// 				$(dialog).dialog(defaults);

	// 			});
	// 		}
	// 	} catch(err){
	// 		return false;
	// 	}
	// };

	/*
	 * Function: release ownership of children to different parent
	 * Purpose:
	 */
	objEntityTypes.releaseOwnership = function(currentId) {
		//Get List of entities affected
		$('#entity-type-reparent-dialog .type-name').html($('#' + currentId + ' .type-name').html());
		var list = '';
		$('.entity.entity-type-' + currentId).each(function() {
			list += '<li>' + $(this).children('.entity-name').text() + '</li>';
		});
		$('#entity-types-to-reparent').html(list);
		$('#entity-new-type option').removeAttr('disabled');
		$('#entity-new-type option[value="'+currentId+'"]').attr('disabled',true);
		$('#entity-new-type').val($('#entity-new-type option:not(:disabled):first').attr('selected', 'selected'));
		var dialog = objDialog.createDOMWarningDialog('entity-type-reparent-dialog', function(dialog, defaults) {
			// Actions
			defaults.buttons = {
				'Re-assign and Delete': function() {
					var postData = {
						newParent : $('#entity-new-type option:selected').val()
					};

					var urlDelete = '/admin/entityType:' + currentId + '.json';
					$.ajax({
						url: urlDelete,
						type: 'delete',
						data: postData,
						success: function (result) {
							if (+result.success === 1) {
								objEntityTypes.refreshList();
							} else {
								objEntityTypes.deleteFailed(currentId);
							}
						}
					});

					$(this).dialog('close');
					$(this).remove();
				},
				Cancel: function() {
					$('#entity-type-' + currentId ).removeClass('curriculog-remove-warning-highlight');
					$(this).dialog('close');
					return false;
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				$('#entity-type-' + currentId ).closest('li').removeClass('curriculog-remove-warning-highlight');
			};
			$(dialog).dialog(defaults);

		});
	};

	objEntityTypes.deleteFailed = function(currentId, typesCount) {
		try {
			if (currentId === undefined || currentId === null) {
				return false;
			}
			var typeId = 'entity-type-' + currentId;
			$('#' + typeId).addClass('curriculog-remove-warning-highlight');

			var dialog;
			if ((typesCount !== undefined && typesCount !== null) && +typesCount === 1) {
				// Prepare Dialog Content
				var list = '';
				$('.' + typeId).each(function() {
					list += '<li>' + $(this).children('.entity-name').text() + '</li>';
				});
				$('#entity-type-owners').append('list');
				$('.entity-type-name').text($('#' + typeId + ' .type-name').html());

				dialog = objDialog.createDOMWarningDialog('entity-delete-type-failed-warning', function(dialog, defaults) {
					// Actions
					defaults.buttons = {
						'Ok': function() {
							$('#' + typeId).removeClass('curriculog-remove-warning-highlight');
							$(this).dialog('close');
							$(this).remove();
						}
					};
					$(dialog).dialog(defaults);

				});
			} else {
				dialog = objDialog.createBasicWarningDialog('delete-failed', function(dialog, defaults) {
					// Message
					$(dialog).append('The "' + $('#' + typeId + ' .type-name').html() + '" entity type could not be deleted at this time.');
					// Actions
					defaults.buttons = {
						'Ok': function() {
							$('#' + typeId).removeClass('curriculog-remove-warning-highlight');
							$(this).dialog('close');
							$(this).remove();
						}
					};
					$(dialog).dialog(defaults);

				});
			}
		} catch (err){
			return false;
		}
	};

	objEntityTypes.verticalStretch = function() {
		var col1 = '#curriculog-hierarchy-column-content';
		var col2 = '#curriculog-types-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2);
	};

	return objEntityTypes;
};